<template>
    <div>
        <section id="blog">
            <div class="back">
                <a href="index.html"></a>
            </div>
            <div class="blog-wrapper">
                <div class="blog-inner">
                    <h1>Headline</h1>
                    <div class="content">
                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.</p>

                        <p>Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi.</p>

                        <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum.</p>
                    </div>
                </div>
                <div class="load-more">
                    <div class="down"></div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data: () => ({
        }),
    }
</script>

<style lang="scss">
    @import "../../../../sass/buddy/new/main.scss";
</style>